import { EPaginationActionTypes } from '../../actions/pagination';
import { EPromosActionTypes } from '../../actions/promos';
import { mapTags } from '../../mappers';

import { TReduxActions } from '../../types/redux';
import { ITag } from '../../types/tags';

const defaultState: ITag[] = [];

export function tagsReducer(state: ITag[] = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EPromosActionTypes.Success:
    case EPaginationActionTypes.Success:
      return mapTags(action.payload);
    default:
      return state;
  }
}
